import { memo } from "react";

export interface CardDataLineProps {
  label: string;
  value: string | { date: string; period: string };
}

const CardDataLine = ({ label, value }: CardDataLineProps) => {
  return (
    <div className="w-full flex flex-row justify-between items-center text-ib-main h-6">
      <div className="text-ib-gray-main">{label}</div>
      {typeof value === "string" ? (
        <div className="text-ib-black">{value}</div>
      ) : (
        <div className="text-ib-black">
          <span className="mr-2">{value.date}</span>
          <span className="font-ib-bold">{value.period}</span>
        </div>
      )}
    </div>
  );
};

export default memo(CardDataLine);
